import keys from '@debbie/common/dist/cache/keys.js';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import { notification } from '@debbie/cortex/dist/notifications.js';
import q from '@debbie/cortex/dist/query.js';
import { tribunalCasesEntity } from '@debbie/cortex/dist/tribunal/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Edit } from '../../Icons/index.js';
import Input from '../../Input.js';
import Modal from '../../Modal.js';
import TribunalCaseJobs from './TribunalCaseJobs.js';
export const TribunalCase = (props) => {
    const lang = useSelector((s) => s.lang);
    const [modalOpen, setModalOpen] = useState(false);
    const [editFSModalOpen, setEditFSModalOpen] = useState(false);
    const [fsNo, setFsNo] = useState(props.tribunalCase.reference || 'FS');
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", { style: { cursor: 'pointer' }, onClick: () => setModalOpen(!modalOpen) },
            React.createElement("td", null, 
            // @ts-ignore
            lang.tribunalCaseTypes[props.tribunalCase.type]),
            React.createElement("td", null, props.tribunalCase.reference),
            React.createElement("td", null, lang.tribunalCaseStatuses[props.tribunalCase.status])),
        modalOpen && (React.createElement(Modal, { header: React.createElement("div", { style: { display: 'inline-flex' } },
                // @ts-ignore
                `${lang.tribunalCaseTypes[props.tribunalCase.type]}${props.tribunalCase.reference
                    ? ` - ${props.tribunalCase.reference}`
                    : ''}`,
                React.createElement(Edit, { style: {
                        cursor: 'pointer',
                        marginLeft: '10px',
                    }, onClick: () => setEditFSModalOpen(true) })), onToggle: () => setModalOpen(!modalOpen) },
            React.createElement(TribunalCaseJobs, { id: props.tribunalCase.id, caseSeqId: props.caseSeqId, tenantId: props.tenantId, tribunalCase: props.tribunalCase }))),
        editFSModalOpen && (React.createElement(Modal, { header: lang.tribunal.editFsNo, onToggle: () => setEditFSModalOpen(!editFSModalOpen) },
            React.createElement("div", null,
                React.createElement(Input, { placeholder: lang.tribunal.fsNo, value: fsNo, onChange: (e) => {
                        setFsNo(e.target.value);
                    }, button: {
                        value: lang.misc.save,
                        onClick: async () => {
                            try {
                                await tribunalAPI.patchCase(props.tribunalCase.id, {
                                    reference: fsNo || null,
                                });
                                if (props.tribunalCase.caseId) {
                                    q.invalidate(keys.write.modify(tribunalCasesEntity, props.tribunalCase.id));
                                }
                                notification({
                                    title: lang.tribunal.FsNoUpdated,
                                });
                                setEditFSModalOpen(false);
                            }
                            catch (error) {
                                alert('Der skete en fejl');
                                console.error(error);
                            }
                        },
                    } }))))));
};
export default TribunalCase;
//# sourceMappingURL=TribunalCase.js.map